import * as React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"
import Header from "./layout/header/Header"
import Footer from "./layout/footer/Footer"
import Banner from "./layout/header/Banner"
import ScrollToTop from "./reusableComponents/ScrollToTop"

const Layout = ({ children }) => {
  const [isMobileNavOpen, setIsMobileNavOpen] = React.useState(false)
  const { pathname } = useLocation()
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  React.useEffect(() => {
    setIsMobileNavOpen(false)
  }, [pathname])

  return (
    <>
      <ScrollToTop showBelow={250} />
      {!isMobileNavOpen && <Banner />}
      <Header
        siteTitle={data.site.siteMetadata?.title || `Title`}
        onNavStateChange={setIsMobileNavOpen}
      />
      {/* <div
        style={{
          margin: `0 auto`,
          maxWidth: 960,
          padding: `0 1.0875rem 1.45rem`,
        }}
      > */}
      <main>{children}</main>
      {/* </div> */}
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
